import {
  MENU_CATEGORIES,
  type MenuCategory,
  type MenuItem,
} from "@/constants/Menu";

export class ArticleToolError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "ArticleToolError";
  }
}

export function findMenuItemByHref(
  categories: readonly MenuCategory[],
  href: string,
): MenuItem | undefined {
  for (const category of categories) {
    const item = category.items.find((item) => item.href === href);
    if (item !== undefined) {
      return item;
    }
  }
  return undefined;
}

export function resolveArticleTool(
  attributes: Record<string, string>,
  categories: readonly MenuCategory[] = MENU_CATEGORIES,
): MenuItem {
  const href = attributes.href;
  if (href === undefined || href === "") {
    throw new ArticleToolError("::tool ディレクティブにhref属性がありません");
  }

  const item = findMenuItemByHref(categories, href);
  if (item === undefined) {
    throw new ArticleToolError(`href(${href})に対応するツールが見つかりません`);
  }

  return item;
}
